import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { createCustomPlant } from '../../../api/api_customPlants';
import { fetchUser } from '../../../api/api_users';

const CreateCustomPlant = () => {
    const { translations } = useLanguage();
    const [name, setName] = useState('');
    const [maxTemperature, setMaxTemperature] = useState('');
    const [maxMinerals, setMaxMinerals] = useState('');
    const [maxGroundHumidity, setMaxGroundHumidity] = useState('');
    const [maxAirHumidity, setMaxAirHumidity] = useState('');
    const [minTemperature, setMinTemperature] = useState('');
    const [minMinerals, setMinMinerals] = useState('');
    const [minGroundHumidity, setMinGroundHumidity] = useState('');
    const [minAirHumidity, setMinAirHumidity] = useState('');
    const [sunlightLevel, setSunlightLevel] = useState('0');

    const [userID, setUserID] = useState(null);
    const navigate = useNavigate();

    const sunlightLevelOptions = [
        { value: 0, label: translations.no_light },
        { value: 1, label: translations.low_ambient_light },
        { value: 2, label: translations.ambient_light },
        { value: 3, label: translations.indirect_solar_light },
        { value: 4, label: translations.direct_solar_light }
    ];

    useEffect(() => {
        const getUserData = async () => {
            try {
                const response = await fetchUser();
                if (response.error) {
                    console.error('Error fetching user:', response.message);
                } else {
                    setUserID(response.data.id);
                }
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };
        getUserData();
    }, []);

    const validateTemperatureInput = value => {
        if (value === '' || /^-?\d+\.?[05]?$/.test(value)) {
            return value;
        }
        return undefined;
    };

    const handleTemperatureChange = (value, setter) => {
        const validValue = validateTemperatureInput(value);
        if (validValue !== undefined) {
            setter(validValue);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const token = localStorage.getItem('userToken');
        const newPlant = {
            name,
            max_temperature: parseFloat(maxTemperature),
            max_minerals: parseInt(maxMinerals),
            max_ground_humidity: parseInt(maxGroundHumidity),
            max_air_humidity: parseInt(maxAirHumidity),
            min_temperature: parseFloat(minTemperature),
            min_minerals: parseInt(minMinerals),
            min_ground_humidity: parseInt(minGroundHumidity),
            min_air_humidity: parseInt(minAirHumidity),
            sunlight_level: parseInt(sunlightLevel),
            user_id: userID
        };

        const newCustomPlant = await createCustomPlant(newPlant, token);
        if (newCustomPlant) {
            alert(translations.custom_plant_added_successfully);
            navigate('/spaces/spaceManager');
        } else {
            alert(translations.failed_to_add_custom_plant);
        }
        navigate(-1);
    };

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className="plant-page">
            <div className="sm-container">
                <div className="header">
                    <button onClick={handleBack} className="back-button">&#8592;</button>
                    <h1>{translations.create_own_plant}</h1>
                </div>
                <form onSubmit={handleSubmit}>
                    <input type="text" className="general-input" placeholder={translations.name} value={name} onChange={e => setName(e.target.value)} required />
                    <input type="text" className="general-input-50" placeholder={translations.max_temperature} value={maxTemperature} onChange={e => handleTemperatureChange(e.target.value, setMaxTemperature)} required />
                    <input type="text" className="general-input-50" placeholder={translations.min_temperature} value={minTemperature} onChange={e => handleTemperatureChange(e.target.value, setMinTemperature)} required />
                    <input type="number" className="general-input-50" placeholder={translations.max_minerals} value={maxMinerals} onChange={e => setMaxMinerals(e.target.value)} required />
                    <input type="number" className="general-input-50" placeholder={translations.min_minerals} value={minMinerals} onChange={e => setMinMinerals(e.target.value)} required />
                    <input type="number" className="general-input-50" placeholder={translations.max_soil_moisture} value={maxGroundHumidity} onChange={e => setMaxGroundHumidity(e.target.value)} required />
                    <input type="number" className="general-input-50" placeholder={translations.min_soil_moisture} value={minGroundHumidity} onChange={e => setMinGroundHumidity(e.target.value)} required />
                    <input type="number" className="general-input-50" placeholder={translations.max_air_humidity} value={maxAirHumidity} onChange={e => setMaxAirHumidity(e.target.value)} required />
                    <input type="number" className="general-input-50" placeholder={translations.min_air_humidity} value={minAirHumidity} onChange={e => setMinAirHumidity(e.target.value)} required />
                    <select className="general-input" value={sunlightLevel} onChange={e => setSunlightLevel(e.target.value)} required>
                        {sunlightLevelOptions.map(option => (<option key={option.value} value={option.value}>{option.label}</option>))}
                    </select>
                    <button type="submit" className="general-button">{translations.create}</button>
                </form>
            </div>
        </div>
    );
};

export default CreateCustomPlant;
